import { render, staticRenderFns } from "./VideoGalleryRecorder.vue?vue&type=template&id=6db430b1&scoped=true&"
import script from "./VideoGalleryRecorder.vue?vue&type=script&lang=js&"
export * from "./VideoGalleryRecorder.vue?vue&type=script&lang=js&"
import style0 from "./VideoGalleryRecorder.vue?vue&type=style&index=0&id=6db430b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db430b1",
  null
  
)

export default component.exports